import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Loading spinner (mockup `.bk-spin`). */
@Component({
  selector: 'app-spinner',
  standalone: true,
  styleUrl: './spinner.component.scss',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input() show = true;
  @Input() label = '';
}
